export default __webpack_public_path__ + "static/media/Nitroxgallery_94.6d17fc85.webp";